/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingReason = {
    AtLeastOneDisputeBlamingFreelancer: 'AT_LEAST_ONE_DISPUTE_BLAMING_FREELANCER',
    BadModerationStatus: 'BAD_MODERATION_STATUS',
    BadRating: 'BAD_RATING',
    ChoiseulProfile: 'CHOISEUL_PROFILE',
    EmailNotVerified: 'EMAIL_NOT_VERIFIED',
    UmbrellaFakeProfile: 'UMBRELLA_FAKE_PROFILE',
    CorporateProgram: 'CORPORATE_PROGRAM',
    NoVerticalAccepted: 'NO_VERTICAL_ACCEPTED',
    ReportAutomaticBehaviour: 'REPORT__AUTOMATIC_BEHAVIOUR',
    ReportAutomaticByPass: 'REPORT__AUTOMATIC_BY_PASS',
    ReportAutomaticFraud: 'REPORT__AUTOMATIC_FRAUD',
    ReportManualBehaviour: 'REPORT__MANUAL_BEHAVIOUR',
    ReportManualByPass: 'REPORT__MANUAL_BY_PASS',
    ReportManualFraud: 'REPORT__MANUAL_FRAUD'
} as const;
export type SourcingReason = typeof SourcingReason[keyof typeof SourcingReason];


export function instanceOfSourcingReason(value: any): boolean {
    for (const key in SourcingReason) {
        if (Object.prototype.hasOwnProperty.call(SourcingReason, key)) {
            // @ts-ignore
            if (SourcingReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingReasonFromJSON(json: any): SourcingReason {
    return SourcingReasonFromJSONTyped(json, false);
}

export function SourcingReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingReason {
    return json as SourcingReason;
}

export function SourcingReasonToJSON(value?: SourcingReason | null): any {
    return value as any;
}

